// extracted by mini-css-extract-plugin
export default {"modalContainer":"uCMy5eCb","modalTitle":"hQgHWS3p"};